<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/bank")
          i.fa.fa-landmark
          span.ml-1 {{ $t("ui.bank") }}
      b-breadcrumb-item
        router-link(to="/bank/bankGroup")
          i.fas.fa-landmark
          span.ml-1 {{ $t("ui.bank_group") }}
  .row.mb-1
    .col-md-12
      b-button.btn-brand(v-b-modal.addBankGroup type="button" variant="info" size="sm").mr-3
        i.fa.fa-plus
        span {{ $t("ui.add_bank_group") }}
  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
          //- i.fa.fa-landmark
          //- span {{ $t("ui.bank_group") }}
        .card-body.p-1
          .table-responsive.mb-0
            table.table.b-table.c-table
              thead
                tr
                  //- th.text-center(width="40px")
                  //-   div #
                  th(width="160px")
                    div {{ $t('ui.group_id') }}
                  th
                    div {{ $t("ui.group_name") }}
                  th(width="120px")
                    div {{ $t("ui.action") }}
                  th.text-center(width="75px")
                    div {{ $t("ui.is_default") }}
                  th.text-right(width="160px")
                    div {{ $t("ui.created_date") }}
              tbody
                tr(v-if="bankGroupList.length <= 0")
                  td(colspan="6").text-center
                    span.text-zero {{ $t('message.no_records') }}
                tr(v-for="(item, index) in bankGroupList")
                  //- td.text-center
                  //-   span {{ index + 1 }}
                  td
                    .text-left
                      span {{ item.group_id }}
                  td
                    .text-left
                      span {{ item.group_name }}
                  td
                    .d-flex.align-items-center.justify-content-start
                      b-link.action-item.fa.fa-edit.text-primary(
                        href="javascript:;"
                        :title="$t('ui.edit_bank_group')"
                        @click="onEditBankGroup(item)"
                        )
                      b-link.action-item.fa.fa-users.text-primary(
                        href="javascript:;"
                        :title="$t('ui.edit_bank_account_group')"
                        @click="onEditBankAccountGroup(item)"
                        )
                      b-link.action-item.fa.fa-flag.text-primary.action-secondary(
                        href="javascript:;"
                        :title="$t('ui.set_default')"
                        @click="onDefault(item)"
                        )
                  td
                    .text-center
                      i(style="font-size: 14px;" :class="{'fas fa-check text-info': item.is_default, 'fas fa-times text-warning': !item.is_default  }")
                  td
                    .text-right
                      span {{ $moment(item.created_date).format('YYYY-MM-DD HH:mm:ss') }}

  addbankgroup(@clicked="addBankGroup" @failed="handleFailed")
  editbankgroup(ref="editbankgroup" :item="editSelectedBankGroup" @clicked="afterEditBankGroup" @failed="handleFailed")
  editbankaccountgroup(ref="editbankaccountgroup" :item="editSelectedBankGroup" @clicked="afterEditBankAccountGroup" @failed="handleFailed")

  #end-report.mt-3
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

import xhr from "@/plugins/xhr.js";

import addbankgroup from "@/components/bank/addBankGroup.vue";
import editbankgroup from "@/components/bank/editBankGroup.vue";
import editbankaccountgroup from "@/components/bank/editBankAccountGroup.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editbankgroup,
    editbankaccountgroup,
    addbankgroup
  },
  data: () => ({
    loading: false,
    bankGroupList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBankGroup: null
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted() {
    this.getBankGroupList();
  },
  methods: {
    addBankGroup() {
      this.search = "";
      this.getBankGroupList();

      this.$helpers.showDialog(this.$t("ui.add_bank_group"), this.$t("message.success"), "success");
    },
    onEditBankGroup(e) {
      this.editSelectedBankGroup = e;
      this.$refs.editbankgroup.$refs.editBankGroup.show();
    },
    onEditBankAccountGroup(e) {
      this.editSelectedBankGroup = e;
      this.$refs.editbankaccountgroup.$refs.editBankAccountGroup.show();
    },
    afterEditBankGroup(item) {
      this.getBankGroupList();
      this.$helpers.showDialog(this.$t("ui.edit_bank_group"), this.$t("message.success"), "success");
    },
    afterEditBankAccountGroup(item) {
      this.getBankGroupList();
      this.$helpers.showDialog(this.$t("ui.edit_bank_account_group"), this.$t("message.success"), "success");
    },
    getBankGroupList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username
      };
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.bankGroupList)
        .then(res => {
          this.loading = false;
          this.bankGroupList = res.data.bankgroup_list;
        })
        .catch(res => {
          this.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    },
    onDefault(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.set_default"),
          text: this.$t("message.change_bank_group_default_confirm", { name: item.group_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankGroupDefault(item);
          }
        });
    },
    confirmBankGroupDefault(item) {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        group_id: item.group_id
      };
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.defaultBankGroup)
        .then(res => {
          this.loading = false;
          this.getBankGroupList();
        })
        .catch(res => {
          this.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
